module.exports = __webpack_public_path__ + "static/media/spicy.5e47acc0.svg";